module.exports = __webpack_public_path__ + "static/media/ab_1.1fd93a0e.png";